import Box from '~/common/components/Box';
import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';

type BreakdownValueWithChildProps = {
  /** The name of the value. */
  name: string;
  /** The value of the field. */
  value?: string | React.ReactNode;
  /** The value for data-testid. */
  testId?: string;
  /** Whether the value should be formatted as a currency. */
  isCurrency?: boolean;
  /** Children data object for each field. */
  childrenData?: any[];
  /** Font weight passed through to the Flex container. */
  fontWeight?: string | number;
};

const BreakdownValueWithChild = ({
  name,
  value,
  testId,
  isCurrency,
  childrenData,
  ...props
}: Readonly<BreakdownValueWithChildProps>) => {
  return (
    <Box>
      <Flex {...props}>
        <Text fontSize="sm">{name}</Text>
        <Text data-testid={testId} fontSize="sm" pl={1}>
          {value && ((isCurrency && formatCurrency(value)) || <>{value}%</>)}
        </Text>
      </Flex>
      {childrenData
        ?.filter((child) => child.value)
        .map((child) => (
          <Box key={child.name}>
            {child.monthlyIncome?.show ? (
              <>
                {child.monthlyIncome?.percentValue ? (
                  <Text data-testid={testId} fontSize="sm" pl={4} pt={1}>
                    {child.value < 0 ? <>-</> : <>+</>}&nbsp;[&nbsp;(
                    {formatCurrency(Math.abs(child.value))}) &#42; (
                    {child.monthlyIncome?.percentValue})&nbsp;]
                  </Text>
                ) : (
                  <Text data-testid={testId} fontSize="sm" pl={4} pt={1}>
                    {child.value < 0 ? <>-</> : <>+</>}&nbsp;
                    {formatCurrency(Math.abs(child.value))}
                  </Text>
                )}
                <Text
                  data-testid={testId}
                  fontSize="sm"
                  borderTop="1px solid"
                  border-width="160px"
                  marginLeft="16px"
                  marginTop="2px"
                  style={{ textIndent: '-6px' }}
                  pl={4}
                >
                  {formatCurrency(child.monthlyIncome?.totalSumValue)}
                  &nbsp; &divide; 12 (Months)
                </Text>
              </>
            ) : (
              <Text data-testid={testId} fontSize="sm" pl={4} pt={1}>
                {isCurrency ? (
                  <>
                    {child?.sign}
                    {formatCurrency(Math.abs(child.value))}
                  </>
                ) : (
                  <>{child.value}%</>
                )}
                &nbsp;
                {child.name && <>({child.name})</>}
              </Text>
            )}
          </Box>
        ))}
    </Box>
  );
};

export default BreakdownValueWithChild;
